import './App.css';
import {
  AppointmentContextProvider,
  DoctorProvider,
  NotificationProvider,
  PatientContextProvider,
  ScheduleContextProvider
} from './context/context';
import { VideoCallProvider } from './context/VideoCallContext';
import AppRoutes from './routes/AppRoutes';
import Notification from './components/Notification';
import VideoCall from './components/VideoCall';
import { useVideoCall } from './context/VideoCallContext';

function AppContent() {
  const { activeCall, endCall } = useVideoCall();

  return (
    <>
      <AppRoutes />
      <Notification />
      {activeCall && (
        <VideoCall
          appointmentId={activeCall.appointmentId}
          role={activeCall.role}
          onEndCall={endCall}
        />
      )}
    </>
  );
}

function App() {
  return (
    <NotificationProvider>
      <DoctorProvider>
        <ScheduleContextProvider>
          <PatientContextProvider>
            <AppointmentContextProvider>
              <VideoCallProvider>
                <AppContent />
              </VideoCallProvider>
            </AppointmentContextProvider>
          </PatientContextProvider>
        </ScheduleContextProvider>
      </DoctorProvider>
    </NotificationProvider>
  );
}

export default App;
